import { buildExecutiveGovernorActivationReport } from "@/governor/activation/ExecutiveGovernorActivationBridge";

export interface TreeGovernorExecutiveBridgeReport {
  governorId: "tree";
  executiveAware: boolean;
  active: boolean;
  maturity: string;
  inventoryStatus: string;
  evidence: string[];
}

export function buildTreeGovernorExecutiveBridgeReport(): TreeGovernorExecutiveBridgeReport {
  const executiveReport = buildExecutiveGovernorActivationReport();
  const tree = executiveReport.supervisedGovernors.find(g => g.id === "tree");

  return {
    governorId: "tree",
    executiveAware: Boolean(tree),
    active: Boolean(tree?.active),
    maturity: tree?.maturity ?? "UNMAPPED",
    inventoryStatus: tree?.inventoryStatus ?? "UNMAPPED",
    evidence: [
      tree ? "tree-governor-placement-found" : "tree-governor-placement-missing",
      ...(tree?.evidence ?? []),
    ],
  };
}

export const TREE_GOVERNOR_EXECUTIVE_BRIDGE_READY = true;
